import { DetalleCarrito } from "./detalle-carrito";

export class Carrito {

  carrId: number;
  tercId_SicaTercero: number;
  costoEnvio: number;
  estado: string;
  fechaCreacion: Date;
  fechaInicio: Date;
  fechaModificacion: Date;
  totalItems: number;
  usuarioCreador: string;
  usuarioModificador: string;
  valorIva: number;
  valorTotal: number;
  listSicaDetalleCarrito: DetalleCarrito[];
  cudeId: number;
  porcentajeDescuento: number;
  valorDescuento: number;

  constructor() { }

}
